export const CrmDataSourceButton = ({
  children,
  source
}) => {
  // TODO: Populate icon with relevant CRM object icon
  // TODO: Populate primary text with the object type name
  // TODO: Populate secondary text with the record's display label
  // TODO: Source click should open the record if a CRM link is available. If not,
  //       we need to pass undefined to the onSourceClick prop to support non-clickable UX.
  // TODO: Loading state while fetching framework data to populate fields

  return children({
    primaryText: source.objectTypeId,
    secondaryText: String(source.objectId),
    onSourceClick: () => {},
    icon: undefined
  });
};